import Vue from 'vue'
import Vuex from 'vuex'
import App from './app'
import router from './router'
import Element from 'element-ui'
import VueQuillEditor from 'vue-quill-editor'
import Antd from 'ant-design-vue'
import BootstrapVue from 'bootstrap-vue'
import store from './store'
import 'ant-design-vue/dist/antd.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/reset.css'
import './styles/index.scss'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/table/iconfont.css'
import './assets/font_jgkye37dm7/iconfont.css'
import './assets/font_pi5xikqkvo7/iconfont.css'
import '../node_modules/mdi/scss/materialdesignicons.scss'
import { setStore, getStore, removeStore } from '@/libs/storage'
import hasRole from '@/libs/hasRole'
import hasField from '@/libs/hasField'
require('es6-promise').polyfill()
Vue.use(Antd)
Vue.use(Element, {
  size: 'medium'
})
Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.config.productionTip = false

Vue.use(VueQuillEditor)
Vue.prototype.setStore = setStore
Vue.prototype.getStore = getStore
Vue.prototype.removeStore = removeStore
Vue.use(hasRole)
Vue.use(hasField)
// let loadingInstance
// 路由前置方法
router.beforeEach((to, from, next) => {
  /*
  let options = {
    lock: true,
    text: '努力加载中',
    spinner: 'el-icon-loading'
  }
  */
  // loadingInstance = Element.Loading.service(options)
  // 判断是否存在token
  // let token = Cookies.get('accesstoken');
  // console.log('获取cookies里的token')
  // console.log(token)
  // console.log(from.fullPath)
  let token = localStorage.getItem('access-token')
  console.log(token)
  if (to.matched.some(record => !record.meta.notRequiresAuth) && (token == null)) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
  } else {
    next()
  }
})

router.afterEach(() => {
  // loadingInstance.close()
})

new Vue({ // eslint-disable-line
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js